import React from 'react';
import PropTypes from 'prop-types';
import { clone, reverse } from 'lodash';
var SvgContextMixin = require('./svgContextMixin');

var SvgChartYearGroupAxis = React.createClass({
  mixins: [SvgContextMixin],

  statics: {
    id: "YearGroupYAxis",
    yearGridId: "YearGroupSingleYearGrid",
    easyLevelColor: "#fbb9b5",
    mediumLevelColor: "#f7e3a6",
    highLevelColor: "#C6EFCE",
    activeGridStroke: "#3b66b1",
    getAxisLength(groupsCount){
      return groupsCount ? groupsCount * 3 : 21;
    }
  },

  propTypes: {
    labels: PropTypes.array.isRequired,
    labelWidth: PropTypes.number,
    activeGroupYear: PropTypes.number,
    displayLabel: PropTypes.string
  },

  componentWillMount(){
    //this.context._define(SvgChartYearGroupAxis.yearGridId, this._getGridSymbol());
  },

  componentWillUnmount(){
    //this.context._undefine(SvgChartYearGroupAxis.yearGridId);
  },

  render(){
    return (
      <g id={SvgChartYearGroupAxis.id}>
        {this._getLabel()}
        {this._getGrid()}
      </g>
    );
  },

  _getLabel(){
    var {displayLabel, box} = this.props;
    if (!displayLabel) return null;

    var x = this.context.relativeX(box[0]) + this.context.width / 100,
      y = this.context.relativeY(box[1] + box[3] / 2),
      fontSize = this.context.getFontSize(this.context.relativeY(box[3]) / 42),
      transform = "rotate(-90 " + x + "," + y + ")";

    return <text x={x} y={y}
                 fontFamily={this.context.font}
                 fontSize={fontSize}
                 transform={transform}
                 dominantBaseline="hanging"
                 textAnchor="middle"
    >
      {displayLabel}
    </text>
  },

  _getGrid(){
    var {box, labels, labelWidth, activeGroupYear} = this.props;

    var gridCount = labels.length,
      gridLineHeight = this.context.relativeY(box[3]) / gridCount,
      gridLineWidth = this.context.relativeX(box[2]) - this.context.relativeX(labelWidth);

    var y = this.context.relativeY(box[1]),
      x = this.context.relativeX(box[0]) + this.context.relativeX(labelWidth);

    var fontSize = this.context.getFontSize(gridLineHeight / 6);
    var labelPadding = this.context.relativeX(labelWidth) * 0.1;

    var grid = [];

    var orderedLabels = clone(labels);
    reverse(orderedLabels);

    var activeGrid = isFinite(activeGroupYear)
      ? (labels.length - activeGroupYear - 1)
      : -1;

    for (var i = 0; i < gridCount; i++) {

      var y0 = y + gridLineHeight * i,
        labelY = y0 + gridLineHeight / 2;

      var gridStroke = activeGrid === i
        ? SvgChartYearGroupAxis.activeGridStroke
        : "none";

      grid = grid.concat(this.getLevelGrid(x, y0, gridLineWidth, gridLineHeight, gridStroke, i));
      grid.push(
        <text
          key={"year-label-" + i}
          x={x - labelPadding}
          y={labelY}
          textAnchor="end"
          dominantBaseline="central"
          fontFamily={this.context.font}
          fontSize={fontSize}
        >
          {orderedLabels[i]}
        </text>
      );
    }

    return grid;
  },

  getLevelGrid(x, y, width, height, gridStroke, key){
    var lineHeight = height / 3;
    return [
      <rect x={x} y={y} key={"hight-"+key}
            width={width}
            height={lineHeight}
            fill={SvgChartYearGroupAxis.highLevelColor}
            stroke="none"/>,
      <rect x={x} y={y + lineHeight} key={"medium-"+key}
            width={width}
            height={lineHeight}
            fill={SvgChartYearGroupAxis.mediumLevelColor}
            stroke="none"/>,
      <rect x={x} y={y + (2 * lineHeight)} key={"low-"+key}
            width={width}
            height={lineHeight}
            fill={SvgChartYearGroupAxis.easyLevelColor}
            stroke="none"/>,
      <rect x={x+1} y={y+1} key={'active-year-'+key}
            width={width-2}
            height={height-2}
            fill="none"
            stroke={gridStroke}
            strokeWidth="2"/>
    ];
  },

  _getGridSymbol(){
    var height = 100 / 3;

    return (
      <symbol id={SvgChartYearGroupAxis.yearGridId}
              key={SvgChartYearGroupAxis.yearGridId} opacity={0.85}>
        <rect x="0" y="0"
              width="100%"
              height={height + "%"}
              fill={SvgChartYearGroupAxis.highLevelColor}
              stroke="none"/>
        <rect x="0" y={height + "%"}
              width="100%"
              height={height + "%"}
              fill={SvgChartYearGroupAxis.mediumLevelColor}
              stroke="none"/>
        <rect x="0" y={ (2 * height) + "%"}
              width="100%"
              height={height + "%"}
              fill={SvgChartYearGroupAxis.easyLevelColor}
              stroke="none"/>
        <rect x="0" y="0"
              width="100%"
              height="100%"
              fill="none"
              strokeWidth="3"/>
      </symbol>
    )
  }

});


module.exports = SvgChartYearGroupAxis;
